// extracted by mini-css-extract-plugin
export default {"container":"info-links_container__-2sQq","separator":"info-links_separator__pP+jo"};